import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'
import { white } from '@edulastic/colors'

const IconBehaviourReportAddOn = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="121.52"
    height="98.085"
    viewBox="0 0 121.52 98.085"
    {...props}
  >
    <g
      id="Group_11785"
      data-name="Group 11785"
      transform="translate(-0.002 -0.661)"
    >
      <path
        id="Path_11195"
        data-name="Path 11195"
        d="M637.682,148.664c-2.565,1.538-7.135,3.466-11.8,1.485l-3.019-1.28,6.049-6.781a28.89,28.89,0,1,1,8.774,6.577Zm-11.59-26.031a24.008,24.008,0,0,0,7.644,17.664l1.669,1.568-3.807,4.267a12.708,12.708,0,0,0,4.585-2.1l1.2-.855,1.292.71a24.239,24.239,0,1,0-12.585-21.256Z"
        transform="translate(-557.678 -93.127)"
        fill="#3f3d56"
        opacity="0.096"
      />
      <path
        id="Path_11196"
        data-name="Path 11196"
        d="M638.315,136.8a26.576,26.576,0,1,1,13.8,23.316c-1.838,1.308-6.321,3.916-10.75,2.037l5.331-5.976a26.511,26.511,0,0,1-8.385-19.376Z"
        transform="translate(-572.251 -107.291)"
        fill="#53b095"
      />
      <path
        id="Path_11197"
        data-name="Path 11197"
        d="M839.991,137.215a26.587,26.587,0,0,0-24.236-26.482c.774-.068,1.558-.1,2.35-.1a26.586,26.586,0,1,1,0,53.172c-.791,0-1.573-.037-2.346-.1A26.587,26.587,0,0,0,839.991,137.215Z"
        transform="translate(-725.284 -107.652)"
        opacity="0.1"
        style={{ mixBlendMode: 'normal', isolation: 'isolate' }}
      />
      <path
        id="Path_11198"
        data-name="Path 11198"
        d="M204.471,397.989a28.967,28.967,0,1,1,21.42-9.482l6.049,6.781-3.019,1.28c-4.67,1.981-9.24.053-11.8-1.485A29,29,0,0,1,204.471,397.989Zm0-53.172a24.236,24.236,0,1,0,11.653,45.491l1.29-.709,1.2.855a12.708,12.708,0,0,0,4.585,2.1l-3.807-4.267,1.669-1.568a24.008,24.008,0,0,0,7.644-17.664A24.264,24.264,0,0,0,204.471,344.817Z"
        transform="translate(-173.085 -305.519)"
        fill="#3f3d56"
        opacity="0.096"
      />
      <path
        id="Path_11199"
        data-name="Path 11199"
        d="M246.087,384.188a26.576,26.576,0,1,0-13.8,23.316c1.838,1.308,6.321,3.916,10.75,2.037l-5.331-5.976A26.511,26.511,0,0,0,246.087,384.188Z"
        transform="translate(-188.115 -320.654)"
        fill="#53b095"
      />
      <path
        id="Path_11200"
        data-name="Path 11200"
        d="M197.614,383.212a26.587,26.587,0,0,1,24.236-26.482c-.774-.068-1.558-.1-2.35-.1a26.586,26.586,0,0,0,0,53.172c.791,0,1.573-.037,2.346-.1A26.587,26.587,0,0,1,197.614,383.212Z"
        transform="translate(-188.115 -319.812)"
        opacity="0.1"
        style={{ mixBlendMode: 'normal', isolation: 'isolate' }}
      />
      <path
        id="Path_11201"
        data-name="Path 11201"
        d="M792.812,222.73a6.757,6.757,0,0,0-5.181-3.076s-3.354-.429-5.5,4.048c-2.005,4.172-4.772,8.2-.446,9.178l.782-2.433.484,2.614a16.927,16.927,0,0,0,1.851.032c4.634-.15,9.047.044,8.9-1.619C793.514,229.263,794.486,225.558,792.812,222.73Z"
        transform="translate(-693.921 -201.671)"
        fill="#2f2e41"
      />
      <path
        id="Path_11202"
        data-name="Path 11202"
        d="M789.844,419.536a6.867,6.867,0,0,1-.222.955c-.109.306-.277.589-.376.9a3,3,0,0,0,.825,2.846,4.643,4.643,0,0,0,2.264,1.344,9.235,9.235,0,0,0,1.946.2,15.1,15.1,0,0,0,5.377-.465,9.338,9.338,0,0,0,1.562-.71,1.169,1.169,0,0,0,.405-.319,1.115,1.115,0,0,0,.146-.655c0-.767-.159-1.529-.122-2.295a9.1,9.1,0,0,0,.061-1.271,2.344,2.344,0,0,0-1.792-2.019,4.866,4.866,0,0,0-1.485,0,37.867,37.867,0,0,1-3.865.173c-1.318-.008-2.629-.21-3.941-.231-.388-.006-.38.113-.5.489a9.149,9.149,0,0,0-.279,1.054Z"
        transform="translate(-702.331 -372.737)"
        fill="#2f2e41"
      />
      <path
        id="Path_11203"
        data-name="Path 11203"
        d="M811.576,281.7a2.3,2.3,0,0,1-.331.948c-.229.314-.6.493-.85.793a2.593,2.593,0,0,0-.394,1.673,2.061,2.061,0,0,0,1.092,2.25,7.159,7.159,0,0,0,3.7,1.558,1.969,1.969,0,0,0,1.537-.559,2.307,2.307,0,0,0,.372-.664,8.817,8.817,0,0,0,.624-2.684,3.151,3.151,0,0,0-.119-1.289,11.9,11.9,0,0,0-.719-1.275,2.839,2.839,0,0,1-.273-1.68.181.181,0,0,0-.01-.122.177.177,0,0,0-.146-.059l-2.694-.194a5.864,5.864,0,0,1-.748-.086c-.145-.03-.529-.236-.667-.181C811.7,280.229,811.628,281.423,811.576,281.7Z"
        transform="translate(-720.321 -253.828)"
        fill="#a0616a"
      />
      <path
        id="Path_11204"
        data-name="Path 11204"
        d="M811.576,282.31a2.3,2.3,0,0,1-.331.948c-.229.314-.6.493-.85.793a2.593,2.593,0,0,0-.394,1.673,2.061,2.061,0,0,0,1.092,2.25,7.159,7.159,0,0,0,3.7,1.558,1.969,1.969,0,0,0,1.537-.559,2.307,2.307,0,0,0,.372-.664,8.817,8.817,0,0,0,.624-2.684,3.152,3.152,0,0,0-.119-1.289,11.9,11.9,0,0,0-.719-1.275,2.839,2.839,0,0,1-.273-1.68.181.181,0,0,0-.01-.122.177.177,0,0,0-.146-.059l-2.694-.194a5.859,5.859,0,0,1-.748-.086c-.145-.03-.529-.236-.667-.181C811.7,280.84,811.628,282.035,811.576,282.31Z"
        transform="translate(-720.321 -254.355)"
        opacity="0.1"
      />
      <circle
        id="Ellipse_634"
        data-name="Ellipse 634"
        cx="3.952"
        cy="3.952"
        r="3.952"
        transform="translate(89.879 20.327)"
        fill="#a0616a"
      />
      <path
        id="Path_11205"
        data-name="Path 11205"
        d="M816.531,313.312a2.425,2.425,0,0,0,.694.555,2.182,2.182,0,0,0,.867.165,2.615,2.615,0,0,0,1.98-.623c.639-.66.618-1.725,1.119-2.5a.557.557,0,0,1,.161-.176.523.523,0,0,1,.274-.063,2.843,2.843,0,0,1,1.681.8,2.214,2.214,0,0,1,.592.6,2.041,2.041,0,0,1,.2.611,26.832,26.832,0,0,1,.406,3.663c.044.678.088,1.356.084,2.035A29.423,29.423,0,0,1,823.542,325a1.034,1.034,0,0,1-.413.728,1.018,1.018,0,0,1-.36.088,44.078,44.078,0,0,1-4.457.371q-.873.013-1.745-.042a.941.941,0,0,1-.294-.051.829.829,0,0,1-.32-.272,5.839,5.839,0,0,1-.849-3.719q.019-4.759.34-9.51a1.046,1.046,0,0,0-.167-.785,9.821,9.821,0,0,0,1.255,1.509Z"
        transform="translate(-724.722 -280.18)"
        fill={white}
      />
      <path
        id="Path_11206"
        data-name="Path 11206"
        d="M781.148,294.462a13.814,13.814,0,0,1-1.308,1.042c-1.062,1.119-3,1.077-3.97,2.276a3.735,3.735,0,0,0-.65,1.478,3.536,3.536,0,0,0,.026,2.26,11.215,11.215,0,0,0,1.349,1.747,6.729,6.729,0,0,1,.878,2.253,5.186,5.186,0,0,1,.24,1.77,10.7,10.7,0,0,1-.587,1.951,2.073,2.073,0,0,0,.221,1.943,2.217,2.217,0,0,0,1.338.61,15.368,15.368,0,0,0,1.907.166,2.323,2.323,0,0,0,1.618-.332,1.627,1.627,0,0,0,.51-1.192,7.7,7.7,0,0,0-.131-1.327c-.06-.458-.083-.919-.1-1.38q-.13-3.1-.036-6.21a5.286,5.286,0,0,0-.063-1.289,7.063,7.063,0,0,0-.67-1.558,5.9,5.9,0,0,1-.654-3.115C781.14,294.447,781.623,293.6,781.148,294.462Z"
        transform="translate(-690.176 -265.894)"
        fill={white}
      />
      <path
        id="Path_11207"
        data-name="Path 11207"
        d="M851.185,292.129c.2.209.894.278,1.153.412a4.041,4.041,0,0,0,.758.262,9.839,9.839,0,0,1,2.662,1.222,1.615,1.615,0,0,1,.445.385,1.763,1.763,0,0,1,.246.7,5.919,5.919,0,0,1-.212,3.886l-.758,2.423a25.986,25.986,0,0,0-1.294,5.523,12.992,12.992,0,0,0,.117,3.137.372.372,0,0,1-.038.3.3.3,0,0,1-.186.085,1.82,1.82,0,0,1-1.051-.294,11.64,11.64,0,0,0-3.209-1.05,7.457,7.457,0,0,0,1-2.054,12.437,12.437,0,0,0,.3-1.413l.352-2.039a20.025,20.025,0,0,0,.3-2.255,2.821,2.821,0,0,0-.049-.849,4.119,4.119,0,0,0-.322-.766,6.545,6.545,0,0,1-.625-3.909,5.711,5.711,0,0,0,.213-1.738,12.243,12.243,0,0,0-.14-1.546C850.26,290.279,850.8,291.736,851.185,292.129Z"
        transform="translate(-754.663 -263.476)"
        fill={white}
      />
      <path
        id="Path_11208"
        data-name="Path 11208"
        d="M775.057,324.574a9.239,9.239,0,0,0-.858,1.609,3.516,3.516,0,0,0-.075.841,4,4,0,0,0,.125,1.265c.084.261.221.5.32.757a2.743,2.743,0,0,1,.18,1.121c-.027.529-.206,1.043-.221,1.573a5.091,5.091,0,0,0,.739,2.361,1.735,1.735,0,0,1,2.523-.826.517.517,0,0,0,.114-.377q.042-1.45.08-2.9a17.34,17.34,0,0,0-.264-4.466,4.213,4.213,0,0,0-.84-1.822c-.233-.268-1.025-.975-1.408-.675-.172.135-.132.5-.159.69a2.928,2.928,0,0,1-.255.85Z"
        transform="translate(-689.373 -290.777)"
        fill={white}
      />
      <path
        id="Path_11209"
        data-name="Path 11209"
        d="M871.372,314.354a4.048,4.048,0,0,1,.135,1.217q.008,1.254-.033,2.507a4.673,4.673,0,0,1-.163,1.269c-.086.269-.218.521-.306.789a7.393,7.393,0,0,0-.1,2.52,2.863,2.863,0,0,1-.069.815,6.714,6.714,0,0,1-.777,1.423,13.993,13.993,0,0,1-.7,1.378,1.314,1.314,0,0,1-1.311.625,1.447,1.447,0,0,1-.832-.776,3.8,3.8,0,0,1-.393-2.468c.186-1.026.789-1.937,1.007-2.957.3-1.4-.155-2.847-.142-4.279a2.068,2.068,0,0,1,.09-.663,2.778,2.778,0,0,1,.585-.851,10.738,10.738,0,0,0,.787-1.032c.162-.242.382-.863.669-.915C870.466,312.841,871.213,313.858,871.372,314.354Z"
        transform="translate(-769.282 -282.141)"
        fill={white}
      />
      <path
        id="Path_11210"
        data-name="Path 11210"
        d="M733.919,423.952a3.9,3.9,0,0,0-1.085-.115,2.709,2.709,0,0,0-2.515,3.193,4.549,4.549,0,0,0,.43,1.175,3.927,3.927,0,0,0,1.166,1.541,4.54,4.54,0,0,0,1.029.49l2.806,1.057c.413.156.826.311,1.243.455a24.305,24.305,0,0,0,6.49,1.29,7.027,7.027,0,0,0,2.015-.1.656.656,0,0,0,.413-.223.706.706,0,0,0,.092-.3l.173-1.209a1.013,1.013,0,0,0-.015-.51.976.976,0,0,0-.466-.44c-1.845-1.06-4-1.644-5.552-3.1-.366-.342-.672-.885-1.116-1.118-.5-.264-1.1-.414-1.617-.657A17.9,17.9,0,0,0,733.919,423.952Z"
        transform="translate(-651.562 -377.775)"
        fill="#2f2e41"
      />
      <path
        id="Path_11211"
        data-name="Path 11211"
        d="M769.258,434.8a29.111,29.111,0,0,1,5.9,3.216c-.1.035-3.361-1.795-3.458-1.824a19.724,19.724,0,0,1-2.631-.927c-.17-.079-1.105-.448-1.063-.663C768.051,434.355,769.082,434.741,769.258,434.8Z"
        transform="translate(-684.099 -386.99)"
        opacity="0.1"
      />
      <path
        id="Path_11212"
        data-name="Path 11212"
        d="M841.6,479.217a.233.233,0,0,0,.157-.046.243.243,0,0,0,.049-.181l0-1.647a5.062,5.062,0,0,0-1.523-.367l-2.426-.324c.056.007-.379,1.045-.313,1.183.118.244,1.016.46,1.27.576A6.348,6.348,0,0,0,841.6,479.217Z"
        transform="translate(-744.063 -423.327)"
        fill="#a0616a"
      />
      <path
        id="Path_11213"
        data-name="Path 11213"
        d="M802.386,474.222a1.966,1.966,0,0,0-1.266.494,1.8,1.8,0,0,0-.037,1.686.547.547,0,0,0,.638.456,2.2,2.2,0,0,0,1.227-.158,5.369,5.369,0,0,0,.477-.354,3.057,3.057,0,0,1,.877-.4,8.864,8.864,0,0,1,1.76-.363,2.735,2.735,0,0,0,.693-.122.768.768,0,0,0,.488-.474,1.129,1.129,0,0,0-.256-.867,3.458,3.458,0,0,0-.738-.912c-.452-.351-.676-.082-1.131.143A9.6,9.6,0,0,1,802.386,474.222Z"
        transform="translate(-712.464 -420.212)"
        fill="#a0616a"
      />
      <path
        id="Path_11214"
        data-name="Path 11214"
        d="M768.352,477.926l-2.909-.86a3.849,3.849,0,0,0-1.082-.21,1.3,1.3,0,0,0-.994.4,1.937,1.937,0,0,0-.346.97l-.12.734a3.689,3.689,0,0,0-.067,1.127,1.247,1.247,0,0,0,.578.929,1.99,1.99,0,0,0,1.345.02,14.644,14.644,0,0,1,2.756-.3,2.213,2.213,0,0,0,1.021-.163,1.275,1.275,0,0,0,.622-1.016C769.212,478.938,769,478.119,768.352,477.926Z"
        transform="translate(-679.628 -423.504)"
        fill="#2f2e41"
      />
      <path
        id="Path_11215"
        data-name="Path 11215"
        d="M867.68,475.51a7.061,7.061,0,0,0,1.071-.407,4.764,4.764,0,0,1,1.6-.176.774.774,0,0,1,.912.871l.243,1.7a2.673,2.673,0,0,1,.02.965.908.908,0,0,1-.6.7,1.784,1.784,0,0,1-1.112-.3,27.043,27.043,0,0,0-2.877-.6.645.645,0,0,1-.431-.308.7.7,0,0,1-.034-.294,7.4,7.4,0,0,1,.065-1.818C866.685,475.378,867.259,475.51,867.68,475.51Z"
        transform="translate(-769.004 -421.837)"
        fill="#2f2e41"
      />
      <path
        id="Path_11216"
        data-name="Path 11216"
        d="M844.144,418.755a5.051,5.051,0,0,1,1.779-.122,1.875,1.875,0,0,1,1.883,2.117,5.007,5.007,0,0,1-1.088,3.2,2.9,2.9,0,0,1-.622.6,4.1,4.1,0,0,1-.81.39L839,427.416a40.6,40.6,0,0,1-5.037,1.736.393.393,0,0,1-.528-.191,13.02,13.02,0,0,1-1.377-2.52.17.17,0,0,1,.075-.268l4.445-2.554a4.5,4.5,0,0,0,.9-.623,2.247,2.247,0,0,0,.464-.647c.092-.192.1-.647.218-.789s.509-.15.691-.205a6.275,6.275,0,0,0,.753-.285c.994-.445,1.88-1.091,2.833-1.612A7.268,7.268,0,0,1,844.144,418.755Z"
        transform="translate(-739.313 -373.264)"
        fill="#2f2e41"
      />
      <path
        id="Path_11217"
        data-name="Path 11217"
        d="M857.1,430.52c-.764.574-1.752,1.1-2.509,1.689-.258.2-4.564,2.622-4.625,2.943.706.119,5.2-3.028,5.848-3.342a10.392,10.392,0,0,0,1.779-1.2c.144-.112.755-.449.341-.574C857.7,429.971,857.275,430.406,857.1,430.52Z"
        transform="translate(-754.792 -383.122)"
        opacity="0.1"
      />
      <path
        id="Path_11218"
        data-name="Path 11218"
        d="M814.71,297.693h-6.7a1.027,1.027,0,0,0-1.027,1.027v.376h-.073v.841h.073v.589h-.073v.5h.073v6.205a1.027,1.027,0,0,0,1.027,1.027h6.7a1.027,1.027,0,0,0,1.027-1.027v-8.515a1.027,1.027,0,0,0-1.027-1.027Z"
        transform="translate(-717.653 -268.985)"
        fill="#d0cde1"
      />
      <path
        id="Path_11219"
        data-name="Path 11219"
        d="M656.5,135.734l-3.4-1.781-4.7.729-.971,4.29,2.418-.093.675-1.576v1.55l1.116-.043.648-2.51.4,2.671,3.967-.081Z"
        transform="translate(-558.376 -114.958)"
        fill="#2f2e41"
      />
      <path
        id="Path_11220"
        data-name="Path 11220"
        d="M783.193,347.065a1.768,1.768,0,0,0,.635.631,1.241,1.241,0,0,0,1.091-.029,1.92,1.92,0,0,0,.787-.789,3.928,3.928,0,0,0,.4-2.182c-.046-.748-.206-1.485-.277-2.232-.051-.543-.056-1.089-.06-1.634a.543.543,0,0,1,.069-.33.649.649,0,0,1,.364-.182,2.931,2.931,0,0,0,1.6-1.613,2.8,2.8,0,0,0,.4-1.485,1.166,1.166,0,0,0-.934-1.092,1.5,1.5,0,0,0-1.127.525,4.831,4.831,0,0,0-1.415,2.827,10.955,10.955,0,0,1-.191,1.577c-.306,1.091-1.262,1.759-1.738,2.741A3.306,3.306,0,0,0,783.193,347.065Z"
        transform="translate(-696.62 -302.13)"
        fill="#a0616a"
      />
      <path
        id="Path_11221"
        data-name="Path 11221"
        d="M861.811,322.506a2.061,2.061,0,0,1-1.156,1.111,1.6,1.6,0,0,1-1,.062,1.114,1.114,0,0,1-.736-.658,1.772,1.772,0,0,1-.083-.495,5.1,5.1,0,0,1,.238-2.18c.1-.265.242-.516.323-.789a3.952,3.952,0,0,0,.122-.962l.088-2.007a1.3,1.3,0,0,0-.03-.435,1.375,1.375,0,0,0-.608-.652,4,4,0,0,1-1.487-1.578,1.107,1.107,0,0,1-.1-.654,1.086,1.086,0,0,1,.882-.743,1.972,1.972,0,0,1,2.365,1.589c.039.226.039.458.062.686.049.485.2.953.3,1.431.237,1.177.114,2.394.349,3.571C861.527,320.787,862.267,321.429,861.811,322.506Z"
        transform="translate(-761.168 -281.737)"
        fill="#a0616a"
      />
      <circle
        id="Ellipse_635"
        data-name="Ellipse 635"
        cx="0.841"
        cy="0.841"
        r="0.841"
        transform="translate(92.954 31.541)"
        fill="#53b095"
      />
      <circle
        id="Ellipse_636"
        data-name="Ellipse 636"
        cx="2.481"
        cy="2.481"
        r="2.481"
        transform="translate(0.002 57.644)"
        fill="#2f2e41"
      />
      <path
        id="Path_11222"
        data-name="Path 11222"
        d="M59.845,478.895,58.6,477.68l-2.509.779.241,2.905,5.159-.24L59.9,478.971Z"
        transform="translate(-48.37 -411.405)"
        fill="#fbbebe"
      />
      <circle
        id="Ellipse_637"
        data-name="Ellipse 637"
        cx="4.011"
        cy="4.011"
        r="4.011"
        transform="translate(4.731 59.443)"
        fill="#fbbebe"
      />
      <path
        id="Path_11223"
        data-name="Path 11223"
        d="M388.712,617.061s4.927,8.467,6.1,9.739a21.277,21.277,0,0,0,1.779,1.773s-.551,1.828-1.429,1.763a4.131,4.131,0,0,1-1.448-.357,3.514,3.514,0,0,0-1.075-1.461c-.684-.445-6.268-5.939-6.137-7.7S388.712,617.061,388.712,617.061Z"
        transform="translate(-355.071 -544.424)"
        fill="#2f2e41"
      />
      <path
        id="Path_11224"
        data-name="Path 11224"
        d="M275.023,670.824s5.253,4.078,12.393.246l.615-.453a24.23,24.23,0,0,0-1.135,2.969,22.806,22.806,0,0,1-3.256,5.242,1.144,1.144,0,0,0-.538.4l1.872,2.061.692-.509a53.977,53.977,0,0,1,3.488-4.523c.789-.7,4.551-7.913,4.551-7.913s1.438-2.718-2.151-2.923-5.24.774-5.24.774l-6.369,1.012Z"
        transform="translate(-258.93 -586.104)"
        fill="#2f2e41"
      />
      <path
        id="Path_11225"
        data-name="Path 11225"
        d="M436.593,697.841l2.657,1.839s3.39,1.062,1.3,1.769-7.591.962-7.716-.013.217-2.51.492-2.426A2.837,2.837,0,0,0,436.593,697.841Z"
        transform="translate(-395.013 -614.093)"
        fill="#2f2e41"
      />
      <path
        id="Path_11226"
        data-name="Path 11226"
        d="M326.1,764.523l.492,2.7s1.4,2.675-.281,1.845-5.138-3.982-4.628-4.643,1.638-1.378,1.753-1.162A2.41,2.41,0,0,0,326.1,764.523Z"
        transform="translate(-299.128 -670.483)"
        fill="#2f2e41"
      />
      <path
        id="Path_11227"
        data-name="Path 11227"
        d="M217.926,589.039s-3.571,4.169-5.739,3.157-11.038-12.744-10.025-14.912,1.352-1.707,1.352-1.707l4.58.424-1.318-2.113a.891.891,0,0,1,1.2.183c.586.636,2.94,2.223,3.76,4.465a3.369,3.369,0,0,0,3.228,2.13Z"
        transform="translate(-196.021 -507.055)"
        fill={white}
      />
      <path
        id="Path_11228"
        data-name="Path 11228"
        d="M190.5,469.263l-6.19,6.571-5.545-9.791,5.272-6.37Z"
        transform="translate(-154.173 -395.876)"
        fill="#3f3d56"
      />
      <path
        id="Path_11229"
        data-name="Path 11229"
        d="M193.864,472.6l-5.591,5.774-5.066-8.9,4.646-5.85Z"
        transform="translate(-158.004 -399.289)"
        fill={white}
      />
      <path
        id="Path_11230"
        data-name="Path 11230"
        d="M162.769,575.336l.3.251-.195.38-8.656,2.576-.082-.3.394-.407Z"
        transform="translate(-132.936 -495.629)"
        fill="#b3b3b3"
      />
      <path
        id="Path_11231"
        data-name="Path 11231"
        d="M129.175,515.715l-8.964,2.8-5.464-10.325,8.806-2.212Z"
        transform="translate(-98.962 -435.813)"
        fill="#d0cde1"
      />
      <path
        id="Path_11232"
        data-name="Path 11232"
        d="M185.56,520.584l-.385.283-4.268-7.411.441-.206Z"
        transform="translate(-156.022 -442.083)"
        fill="#3f3d56"
      />
      <path
        id="Path_11233"
        data-name="Path 11233"
        d="M157.553,523.453l-3.792,1.131-4.3-7.621,3.751-.864Z"
        transform="translate(-128.898 -444.54)"
        fill="#3f3d56"
      />
      <path
        id="Path_11234"
        data-name="Path 11234"
        d="M285.671,619.646l.785-.222s4.378-.495,4.442.881-5.03.737-5.03.737l-.679-.923Z"
        transform="translate(-267.698 -546.387)"
        fill="#fbbebe"
      />
      <path
        id="Path_11235"
        data-name="Path 11235"
        d="M310.477,646.545l1.093-.448s3.3-1.479,2.352-2.442-3.864.71-3.864.71l-.559.53Z"
        transform="translate(-288.663 -567.101)"
        fill="#fbbebe"
      />
      <path
        id="Path_11236"
        data-name="Path 11236"
        d="M218.157,618.686s1.779,1.773,1.374,2.19-7.044,5.9-8.689,4.142-9.664-10.554-6.544-11.309,3.944,1.01,3.944,1.01l4.119,7.047Z"
        transform="translate(-197.317 -541.371)"
        fill={white}
      />
      <path
        id="Path_11237"
        data-name="Path 11237"
        d="M111.408,518.781l2.923.991-.048,2.11-3.091-.334Z"
        transform="translate(-95.896 -446.853)"
        fill={white}
      />
      <path
        id="Path_11238"
        data-name="Path 11238"
        d="M89.612,542.75l-3.149,1.843-3.6-5.533,3.473,4.558Z"
        transform="translate(-71.465 -464.342)"
        opacity="0.2"
      />
      <circle
        id="Ellipse_638"
        data-name="Ellipse 638"
        cx="4.775"
        cy="4.775"
        r="4.775"
        transform="translate(2.207 57.517)"
        fill="#2f2e41"
      />
      <path
        id="Path_11239"
        data-name="Path 11239"
        d="M217.338,490.753l-3.343-4.891,1.417-1.754,3.474,5.032Z"
        transform="translate(-184.558 -416.949)"
        fill="#53b095"
      />
      <path
        id="Path_11240"
        data-name="Path 11240"
        d="M205.7,498.416l-5.09-7.4.251-.3,5.066,7.417Z"
        transform="translate(-173.017 -422.646)"
        fill="#e6e6e6"
      />
      <path
        id="Path_11241"
        data-name="Path 11241"
        d="M200.935,503.65l-5.09-7.4.251-.3,5.066,7.417Z"
        transform="translate(-168.905 -427.16)"
        fill="#e6e6e6"
      />
      <path
        id="Path_11242"
        data-name="Path 11242"
        d="M196.873,507.5l-5.09-7.4.251-.3,5.066,7.417Z"
        transform="translate(-165.402 -430.481)"
        fill="#e6e6e6"
      />
      <path
        id="Path_11243"
        data-name="Path 11243"
        d="M66.117,425.544h1.477a2.82,2.82,0,0,1,2.82,2.82h-4.3Z"
        transform="translate(-57.021 -366.441)"
        fill="#2f2e41"
      />
      <path
        id="Path_11244"
        data-name="Path 11244"
        d="M364.609,505.526l-.612-.046c-.024.318-.041.638-.061.958l-2.747-.092,2.882,5.4,3.237-5.2-2.757-.092C364.569,506.148,364.586,505.837,364.609,505.526Z"
        transform="translate(-334.701 -451.432)"
        fill="#3f3d56"
      />
      <path
        id="Path_11245"
        data-name="Path 11245"
        d="M423.317,357.765l.213.163c.32-.419.655-.838.994-1.244l-.206-.172C423.976,356.921,423.639,357.343,423.317,357.765Z"
        transform="translate(-386.826 -319.713)"
        fill="#3f3d56"
      />
      <path
        id="Path_11246"
        data-name="Path 11246"
        d="M438.272,340.452l.2.181c.356-.39.726-.778,1.1-1.152l-.19-.19C439,339.669,438.631,340.059,438.272,340.452Z"
        transform="translate(-399.724 -304.862)"
        fill="#3f3d56"
      />
      <path
        id="Path_11247"
        data-name="Path 11247"
        d="M454.736,324.584l.182.2c.39-.358.792-.711,1.2-1.05l-.173-.206C455.534,323.868,455.128,324.224,454.736,324.584Z"
        transform="translate(-413.923 -291.265)"
        fill="#3f3d56"
      />
      <path
        id="Path_11248"
        data-name="Path 11248"
        d="M409.991,376.391l.227.143c.282-.447.579-.893.881-1.328l-.22-.153C410.574,375.491,410.275,375.941,409.991,376.391Z"
        transform="translate(-375.333 -335.705)"
        fill="#3f3d56"
      />
      <path
        id="Path_11249"
        data-name="Path 11249"
        d="M472.579,310.283l.164.213c.42-.322.851-.639,1.283-.941l-.154-.22C473.436,309.64,473,309.959,472.579,310.283Z"
        transform="translate(-429.312 -279.026)"
        fill="#3f3d56"
      />
      <path
        id="Path_11250"
        data-name="Path 11250"
        d="M398.406,396.192l.239.123c.242-.47.5-.942.76-1.4l-.233-.133C398.907,395.243,398.65,395.718,398.406,396.192Z"
        transform="translate(-365.341 -352.718)"
        fill="#3f3d56"
      />
      <path
        id="Path_11251"
        data-name="Path 11251"
        d="M375.654,459.578l-.26-.067c-.133.515-.256,1.041-.365,1.562l.263.055C375.4,460.611,375.523,460.089,375.654,459.578Z"
        transform="translate(-345.18 -408.545)"
        fill="#3f3d56"
      />
      <path
        id="Path_11252"
        data-name="Path 11252"
        d="M491.665,297.664l.144.227c.445-.283.9-.56,1.36-.824l-.134-.233C492.574,297.1,492.113,297.379,491.665,297.664Z"
        transform="translate(-445.772 -268.244)"
        fill="#3f3d56"
      />
      <path
        id="Path_11253"
        data-name="Path 11253"
        d="M371.736,482.37l-.265-.044c-.086.524-.162,1.058-.225,1.588l.267.032C371.575,483.421,371.65,482.89,371.736,482.37Z"
        transform="translate(-341.917 -428.222)"
        fill="#3f3d56"
      />
      <path
        id="Path_11254"
        data-name="Path 11254"
        d="M388.661,417.019l.249.1c.2-.49.412-.983.633-1.464l-.244-.112C389.076,416.029,388.861,416.525,388.661,417.019Z"
        transform="translate(-356.937 -370.626)"
        fill="#3f3d56"
      />
      <path
        id="Path_11255"
        data-name="Path 11255"
        d="M380.841,438.714l.257.078c.155-.507.323-1.017.5-1.515l-.253-.09C381.167,437.69,381,438.2,380.841,438.714Z"
        transform="translate(-350.192 -389.292)"
        fill="#3f3d56"
      />
      <path
        id="Path_11256"
        data-name="Path 11256"
        d="M623.675,262.132c.526-.018,1.063-.026,1.593-.021l0-.269c-.534,0-1.074,0-1.6.021Z"
        transform="translate(-559.617 -238.064)"
        fill="#3f3d56"
      />
      <path
        id="Path_11257"
        data-name="Path 11257"
        d="M511.845,286.829l.124.238c.469-.243.949-.478,1.427-.7l-.113-.244C512.8,286.347,512.317,286.584,511.845,286.829Z"
        transform="translate(-463.177 -259.007)"
        fill="#3f3d56"
      />
      <path
        id="Path_11258"
        data-name="Path 11258"
        d="M669.93,264.721c.524.074,1.052.161,1.571.258l.049-.264c-.523-.1-1.055-.185-1.583-.26Z"
        transform="translate(-599.518 -240.319)"
        fill="#3f3d56"
      />
      <path
        id="Path_11259"
        data-name="Path 11259"
        d="M692.685,269.006c.514.12,1.033.254,1.542.4l.073-.259c-.513-.144-1.036-.279-1.554-.4Z"
        transform="translate(-619.143 -244.018)"
        fill="#3f3d56"
      />
      <path
        id="Path_11260"
        data-name="Path 11260"
        d="M714.969,275.311c.5.165,1.006.345,1.5.532l.1-.251c-.5-.189-1.007-.37-1.512-.536Z"
        transform="translate(-638.361 -249.462)"
        fill="#3f3d56"
      />
      <path
        id="Path_11261"
        data-name="Path 11261"
        d="M646.886,262.478c.529.028,1.063.068,1.588.118l.026-.267c-.529-.051-1.068-.091-1.6-.119Z"
        transform="translate(-579.643 -238.382)"
        fill="#3f3d56"
      />
      <path
        id="Path_11262"
        data-name="Path 11262"
        d="M600.423,262.821l.033.267c.523-.064,1.056-.118,1.584-.16l-.021-.268C601.487,262.7,600.95,262.756,600.423,262.821Z"
        transform="translate(-539.571 -238.771)"
        fill="#3f3d56"
      />
      <path
        id="Path_11263"
        data-name="Path 11263"
        d="M554.878,270.836l.079.256c.5-.156,1.02-.3,1.531-.437l-.068-.26C555.9,270.531,555.386,270.679,554.878,270.836Z"
        transform="translate(-500.29 -245.443)"
        fill="#3f3d56"
      />
      <path
        id="Path_11264"
        data-name="Path 11264"
        d="M532.961,277.867l.1.248c.488-.2.987-.392,1.482-.57l-.091-.253C533.955,277.472,533.453,277.665,532.961,277.867Z"
        transform="translate(-481.388 -251.391)"
        fill="#3f3d56"
      />
      <path
        id="Path_11265"
        data-name="Path 11265"
        d="M577.434,265.809l.056.263c.516-.111,1.042-.211,1.564-.3l-.045-.265C578.484,265.6,577.954,265.7,577.434,265.809Z"
        transform="translate(-519.744 -241.227)"
        fill="#3f3d56"
      />
      <path
        id="Path_11266"
        data-name="Path 11266"
        d="M741.811,281.893l-3.494-5.164-1.229,2.529c-.3-.133-.593-.268-.89-.4l-.248.574c.29.126.577.257.865.386l-1.223,2.517Z"
        transform="translate(-659.988 -253.545)"
        fill="#3f3d56"
      />
    </g>
  </SVG>
)

export default withIconStyles(IconBehaviourReportAddOn)
